import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuthStore } from "@/lib/auth-store";
import { waitForAuthHydration } from "@/lib/auth-hydration";

/**
 * Ruta `/` · siempre redirige · si hay token vamos al dashboard, si no al
 * login. Antes era `app/page.tsx` con useEffect + router.replace · acá
 * lo hacemos en `beforeLoad` para no parpadear "Cargando…".
 */
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    await waitForAuthHydration();
    const { accessToken } = useAuthStore.getState();
    throw redirect({ to: accessToken ? "/dashboard" : "/login" });
  },
});
